import AppRouter from "./routes/AppRouter"
import { BrowserRouter as Router} from "react-router-dom"
import { urlRoute } from "./global";

function App() {
  
  return (
    <div className="App">

    <Router basename={'/'+urlRoute}>
    <AppRouter />
  </Router>
</div>
  );
}

export default App;
